<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-09-24 09:11:38
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-10-18 15:57:23
-->
<template>
  <div class="flex p10 bg-white">
    <div class="w70 f13 f-grey pt10">{{ name || label }}</div>
    <div class="flex-1">
      <el-slider
        v-model="mValue"
        v-bind="mOptions"
        show-input
      >
      </el-slider>
    </div>
  </div>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";

export default {
  name: "SchemaNumber",

  mixins: [schemaMixin],

  props: {
    name: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      defaultOptions: {
        max: 100,
      },
    };
  },
};
</script>